import { FormQuestionOption } from '@models/forms/form-question-option.model';

export enum QuestionType {
  Boolean = 'BOOLEAN',
  Checkbox = 'CHECKBOX',
  Date = 'DATE',
  Multiselect = 'MULTISELECT',
  Text = 'TEXT',
  Textarea = 'TEXTAREA',
  Year = 'YEAR',
  File = 'FILE',
  Time = 'TIME',
}

export interface FormQuestion {
  id: string;
  name: string;
  label: string;
  colSize: number;
  questionType: QuestionType;
  reference: string;
  options: FormQuestionOption[];
  params: string;
}
